import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ExpandableSection from "../../components/ExpandableContent/ExpandableContent";
import pdf from "../../assets/local_hattiesburg_attractions.pdf";
import Tooltip from "../../components/Tooltip/Tooltip";

const Application = ({ defaultTab, deadline }) => {
  const navigate = useNavigate();
  const initialTab = defaultTab >= 0 && defaultTab < 4 ? defaultTab : 0;
  const [tabValue, setTabValue] = useState(initialTab);
  const presentDate = new Date();
  const deadlineDate = new Date(deadline);
  const isExpired = presentDate > deadlineDate;

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  useEffect(() => {
    document.title = "Summer Residency Application - MS Digital Hub";
  }, []);

  return (
    <Box
      sx={{
        width: "auto",

        padding: "0px 20px",
        margin: "0px auto",
        padding: { xs: "20px", sm: "30px", md: "1px 80px" },
        border: "none",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      }}
    >
      <Box
        my={4}
        sx={{
          gap: 4,
          alignItems: "center",
        }}
      >
        <Box>
          <Box sx={{}}>
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{
                textAlign: "center",
                marginBottom: "30px",
              }}
            >
              Apply to Our Digitization Summer Residency Program
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#FFD700",
                  color: "#111111",
                  padding: "12px 20px",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#FFB800" },
                }}
                href="https://usmforms.formstack.com/forms/faculty_dh_workshop_summer_2025_application"
                target="_blank"
                disabled={isExpired}
              >
                {isExpired ? "Deadline passed" : "Apply"}
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: {
                xs: "center",
                sm: "center",
                md: "flex-start",
                lg: "flex-start",
              },
              justifyContent: "space-between",
              padding: "20px",
              gap: { xs: "30px", sm: "30px" },
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "row",
                lg: "row",
              },
            }}
          >
            <Typography variant="body1" sx={{ flex: 1, textAlign: "center" }}>
              <strong>
                Dates
                <br />
              </strong>{" "}
              Monday, June 16, 2025 - Friday, June 27, 2025
            </Typography>
            <Typography variant="body1" sx={{ flex: 1, textAlign: "center" }}>
              <strong>
                Location
                <br />
              </strong>{" "}
              University of Southern Mississippi - Hattiesburg campus
            </Typography>
            <Typography variant="body1" sx={{ flex: 1, textAlign: "center" }}>
              <strong>
                Deadline
                <br />
              </strong>{" "}
              Application closes: Tuesday, April 15, 2025 at 11:59PM (CT)
              <br />
              *Note: Late applications will not be accepted.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Paper
        square
        elevation={0}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="STEP page navigation"
          sx={{ flexWrap: "flex-wrap sm:flex-nowrap" }}
        >
          <Tab label="Qualification" sx={{ fontWeight: "bold" }} />
          <Tab label="Application" sx={{ fontWeight: "bold" }} />
          <Tab label="Timeline" sx={{ fontWeight: "bold" }} />
          <Tab label="FAQs" sx={{ fontWeight: "bold" }} />
        </Tabs>
      </Paper>

      <Box my={4}>
        {tabValue === 0 && (
          <Box>
            <Typography variant="h4" gutterBottom sx={{ mt: 2 }}>
              Qualification
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: "1.8" }} paragraph>
              Applicants must be interested in digital humanities and currently
              work at a Mississippi institution, either in a museum, archive or
              as faculty at a two- or four-year college or university, including
              but not limited to: lecturers, instructors, professor (adjunct,
              visiting, clinical, associate, assistant, full, or distinguished),
              research associate, or research fellows. Applicants must be either
              U.S. citizens, U.S. nationals, or permanent residents of the U.S.
              If selected, participants cannot hold another obligation—such as a
              fellowship, part/full-time work, or teaching a course during the
              program's duration.
            </Typography>
          </Box>
        )}

        {tabValue === 1 && (
          <Box>
            <Typography variant="h4" gutterBottom sx={{ mt: 2 }}>
              Application
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "medium" }}>
              The application requires two uploaded documents:
            </Typography>
            <List>
              <ListItem disableGutters>
                <ListItemText primary="An Updated CV" />
              </ListItem>

              <ListItem disableGutters>
                <ListItemText
                  primary={
                    <ExpandableSection
                      defaultContent="A Personal Statement"
                      expandedContent="In approximately 800 words, describe your interest in learning about the digital humanities and how you see this opportunity benefitting your research, your program, and your students."
                    />
                  }
                />
              </ListItem>

              {/*  <ListItem disableGutters>
                <ListItemText primary= {
                    <ExpandableSection
                    defaultContent="A Description of a potential digital humanities project you are interested in pursuing"
                    expandedContent="Potential Project: Although participants are not required to have a specific digitization or digital humanities project underway, our goal in providing these workshops is to provide you with the tools you will need to undergo a research or community digitization project. In approximately 500 words, provide a description of a potential digital humanities project that you might pursue with students, other faculty or community partners. In your description, include what your data sources are, or where you plan to derive your data from, their format, and where it is located, as well as broadly the types of tools you are interested in applying towards this research. If it is an existing project, please also include a link."
                  />}/>
                
              </ListItem> */}
            </List>
          </Box>
        )}

        {tabValue === 2 && (
          <Box>
            <Typography variant="h4" gutterBottom sx={{ mt: 2 }}>
              Timeline
            </Typography>
            <Box mt={2}>
              <Typography variant="h6" sx={{ fontWeight: "medium" }}>
                Application closes
              </Typography>
              <List>
                <ListItem disableGutters>
                  <ListItemText primary="Tuesday, April 15, 2025 at 11:59PM (CT)" />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemText primary="Note: Late applications will not be accepted." />
                </ListItem>
              </List>
            </Box>
            <Box mt={2}>
              <Typography variant="h6" sx={{ fontWeight: "medium" }}>
                Decision Announcements: TBA
              </Typography>
              <List>
                <ListItem disableGutters>
                  <ListItemText primary="*All applicants will receive decision notifications by 5PM (CT) on Friday, May 2, 2025." />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemText primary="**Due to planning purposes, any and all offer denials and acceptances are final." />
                </ListItem>
              </List>
            </Box>
            <Box mt={2}>
              <Typography variant="h6" sx={{ fontWeight: "medium" }}>
                Program Dates:
              </Typography>
              <List>
                <ListItem disableGutters>
                  <ListItemText primary="Monday, June 16, 2025, - Friday, June 27, 2025" />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemText primary="Residence hall check-in: Between 9AM - 11AM (CT) on Monday, June 16" />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemText primary="Check-out of residence hall: Between 2PM - 4:30PM (CT) on Friday, June 27" />
                </ListItem>
              </List>
            </Box>
          </Box>
        )}

        {tabValue === 3 && (
          <Box>
            <Typography variant="h4" gutterBottom sx={{ mt: 2 }}>
              FAQs
            </Typography>
            <Typography
              variant="h7"
              gutterBottom
              sx={{ fontWeight: "bold", mt: 2 }}
            >
              STIPENDS & REIMBURSEMENT
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Box mb={2}>
              <Typography variant="body1">
                <strong>Q:</strong> How much are participants’ stipends and how
                do we receive it?
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>A:</strong> The stipend for 2025 residential program is
                $1500 total. This will be given in two equal installments: the
                first at the start of the program during check-in and the last
                upon check-out. These are paper checks rather than direct
                deposit. We recommend having a bank account established before
                starting the program to make the deposit process easier.
              </Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body1">
                <strong>Q:</strong> Is there a travel stipend or reimbursement?
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>A:</strong> Participants will be reimbursed up to $500
                for travel expenses to and from the summer program. This may
                include mileage, gas, and/or hotels; participants must provide
                their trip’s start-point and end-point of their trip, as well as
                any receipts, to the program admin and coordinator, Ms. Maeve
                Losen, in order to receive reimbursement.
              </Typography>
            </Box>
            <Typography
              variant="h7"
              gutterBottom
              sx={{ fontWeight: "bold", mt: 2 }}
            >
              ACCOMMODATIONS
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Box mb={2}>
              <Typography variant="body1">
                <strong>Q:</strong> Where will participants be staying during
                the program?
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>A:</strong> Participants will be housed in one of the
                on-campus residence halls with other adult-aged groups. Linens
                (towels, bedding, bath mats) are not provided by USM and must be
                brought by participants; each room has a private bathroom with a
                provided shower curtain liner. Rooms will be shared by two
                participants. There is access to laundry services in the
                residence hall. Additionally, residence halls are not staffed
                24/7, but housing staff typically man the desk from 8PM to 12AM,
                after that, participants have access to a 24/7 on-call resident
                assistant and emergency maintenance. In most cases, participants
                are required to stay in the residence halls, even if they live
                in or near Hattiesburg.
              </Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body1">
                <strong>Q:</strong> Will I have to pay for a meal plan? Is there
                kitchen access in the residence halls?
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>A:</strong> Unfortunately, there is no kitchen access in
                the residence halls. The program will provide participants with
                the majority of meals.
              </Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body1">
                <strong>Q:</strong> If I bring my car, will I have to pay for
                parking?
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>A:</strong> Participants will receive free parking.
              </Typography>
            </Box>
            <Typography
              variant="h7"
              gutterBottom
              sx={{ fontWeight: "bold", mt: 2 }}
            >
              GENERAL QUESTIONS
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Box mb={2}>
              <Typography variant="body1">
                <strong>Q:</strong> What does a typical work-day and week look
                like?
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>A:</strong> Due to the quick-pacing of the program and
                condensed timeline, most days participants will work between 9AM
                and 4PM, with approximately an hour for lunch. Each day may
                include workshops and hands-on activities.
              </Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body1">
                <strong>Q:</strong> Can I pursue other activities while in the
                program?
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>A:</strong> No, this is an intensive program which
                requires participants’ full attention throughout the summer.
                Engaging in other activities (i.e., teaching an online or
                in-person course, planned trip, etc.) would diminish your
                ability to fully learn the material.
              </Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body1">
                <strong>Q:</strong> There’s a planned event during the summer
                (Wedding, graduation, concert, etc.), can I go?
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>A:</strong> Participants are welcome to do non-program
                related activities only if they are outside of the program’s
                schedule, such as the evenings and weekends. Participants are
                expected to attend all scheduled activities. Illness and
                emergencies are exceptions.
              </Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body1">
                <strong>Q:</strong> Are there things to do during the evenings
                and the weekend?
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>A:</strong> There are many indoor and outdoor activities
                in Hattiesburg. There are two movie theaters, numerous museums,
                public festivals and events, and more in the City of
                Hattiesburg—check-out this <Tooltip keyword="list" url={pdf} />.
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Application;
